module.exports = __webpack_public_path__ + "static/img/gzrc.8bbf2b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/gzrc.png
// module id = +Nrw
// module chunks = 93